import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(",")
const _hoisted_4 = { class: "p-d-flex p-jc-end w100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_OrderFilters = _resolveComponent("OrderFilters")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_OrderShiftCell = _resolveComponent("OrderShiftCell")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_OrderPaymentCell = _resolveComponent("OrderPaymentCell")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_AlertDialog = _resolveComponent("AlertDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: _ctx.$t('orders.list.title')
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_router_link, { to: _ctx.newOrderRoute }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              label: "Aggiungi"
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_OrderFilters, {
      modelValue: _ctx.advFilters,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters = $event)),
      schema: _ctx.filters,
      onUpdate: _ctx.updateFilters
    }, null, 8, ["modelValue", "schema", "onUpdate"]),
    _createVNode(_component_AppTable, {
      ref: "dataTable",
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      loading: _ctx.requestPending,
      filtersSchema: _ctx.filters,
      onRowClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit($event.data))),
      onResetFilters: _ctx.onReset
    }, {
      toolbarLeft: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Export",
          icon: "fas fa-file-excel",
          class: "p-button-outlined",
          loading: _ctx.exportInProgress,
          onClick: _ctx.onExport
        }, null, 8, ["loading", "onClick"])
      ]),
      columns: _withCtx(({onApplyFilter}) => [
        _createVNode(_component_Column, {
          header: "TMT ID",
          sortField: "id",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(" #" + _toDisplayString(data.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Codice ordine",
          field: "external_client_code",
          showFilterOperator: false,
          showFilterMatchModes: false
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.external_client_code), 1)
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Codice ordine",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          header: "Indirizzo di consegna",
          field: "dropoff_full_address",
          showFilterOperator: false,
          showFilterMatchModes: false,
          style: {minWidth: '15rem' }
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.dropoff_full_address), 1)
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Indirizzo di consegna",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          header: "Giorno",
          style: {minWidth: '8rem' }
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", null, [
              _createVNode(_component_DateFormatted, {
                date: data.pickup_datetime
              }, null, 8, ["date"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Fascia oraria",
          style: {minWidth: '12rem', width: '12rem' },
          field: "shift_id",
          sortField: "shift_id",
          sortable: true,
          showFilterMatchModes: false
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_OrderShiftCell, { order: data }, null, 8, ["order"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Stato",
          field: "status",
          showFilterMatchModes: false,
          showApplyButton: false,
          showClearButton: false
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", {
              class: _normalizeClass(`order-badge status-${data.status}`)
            }, _toDisplayString(_ctx.$t(`order.status_${data.status}`)), 3)
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statusOptions,
              placeholder: "Filtra per stato",
              class: "p-column-filter",
              optionLabel: "label",
              "option-value": "value",
              onChange: ($event: any) => (onApplyFilter(filterCallback))
            }, {
              value: _withCtx(({value, placeholder}) => [
                (!value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(placeholder), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (v, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: v,
                    class: "p-mr-2"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`order.status_${v}`)) + " ", 1),
                    (i < (value.length -1))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_3
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              option: _withCtx(({option}) => [
                _createElementVNode("div", {
                  class: _normalizeClass(`order-badge status-${option.value}`)
                }, _toDisplayString(_ctx.$t(`order.status_${option.value}`)), 3)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          header: "Pagamento",
          field: "payment_type",
          showFilterMatchModes: false,
          showApplyButton: false,
          showClearButton: false
        }, {
          body: _withCtx(({ data: { 
              payment_type, payment_status, paid_at, payment_amount }
            }) => [
            _createVNode(_component_OrderPaymentCell, {
              payment_type: payment_type,
              payment_status: payment_status,
              paid_at: paid_at,
              payment_amount: payment_amount
            }, null, 8, ["payment_type", "payment_status", "paid_at", "payment_amount"])
          ]),
          filter: _withCtx(() => [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.advFilters.paymentStatus,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.advFilters.paymentStatus = $event)),
              options: _ctx.paymentOptions,
              placeholder: "Filtra per stato pagamento",
              class: "p-column-filter",
              optionLabel: "label",
              "option-value": "value",
              onChange: _ctx.updateFilters
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _: 1
        })
      ]),
      actions: _withCtx(({data}) => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: {
            name: _ctx.orderDetailRoute,
            params: { orderId: data.id }
          }
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_Button, {
                class: "p-button-info p-ml-1",
                icon: "pi pi-eye",
                "aria-haspopup": "true",
                "aria-controls": "overlay_menu"
              }, null, 512), [
                [
                  _directive_tooltip,
                  _ctx.$t('view'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      ]),
      _: 1
    }, 8, ["service", "stateKey", "loading", "filtersSchema", "onResetFilters"]),
    _createVNode(_component_AlertDialog, {
      alertMessage: _ctx.alertMessage,
      showAlertMessage: _ctx.showAlertMessage,
      "onUpdate:showAlertMessage": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAlertMessage = $event))
    }, null, 8, ["alertMessage", "showAlertMessage"])
  ]))
}